const categoryApi = {
  GET_ALL_CATEGORIES: `/api/restaurant/itemcategory`,
  CREATE_CATEGORY: `/api/restaurant/itemcategory/create`,
  UPDATE_CATEGORY: `/api/restaurant/itemcategory/update`,
  DELETE_CATEGORY: `/api/restaurant/itemcategory/delete`,

  IMPORT_CATEGORIES: `/api/restaurant/itemcategory/import`,
};
export default categoryApi;
